import { QueryClient } from "react-query";
import { store } from "../store";
import { resetAuthState } from "@funded-here-interface/common/src/features/auth/authSlice_Admin";
import { SessionInvalidatedError } from "@funded-here-interface/common/src/Utils/axiosSessionInterceptor";

const handleOnError = (message: string) => {
  if (message === "Unauthorized") {
    store.dispatch(resetAuthState());
    window.location.replace("/login");

    return;
  }
};

const client = new QueryClient({
  defaultOptions: {
    mutations: {
      onError: (e) => {
        if (e instanceof SessionInvalidatedError) return;
        handleOnError((e as Error).message);
      },
    },
    queries: {
      onError: (e) => {
        if (e instanceof SessionInvalidatedError) return;
        handleOnError((e as Error).message);
      },
    },
  },
});

export { client };
